<template>
  <div class="PersonalCenter">
    <div class="left">
      <Base @uploadName="uploadName"></Base>
    </div>
    <div class="right">
      <div class="title"><span>我的项目</span></div>
      <div class="cont">
        <div class="projectlist">
          <div class="all">项目列表（{{ projectGroup.length }}个）</div>
          <div class="list">
            <div class="item" v-for="(elm,index) in projectGroup" :class="active==index?'active':''"
                 @click="selItem(elm,index)">
              <img :src="elm.projectImg" alt="">
              <div class="name u-line-1">{{ elm.projectName }}</div>
            </div>
          </div>
        </div>
        <div class="people">
          <div class="tag"><span :class="{active:activeindex==='0'}" @click="activeindex='0'">成员列表</span><span
              :class="{active:activeindex==='1'}" @click="activeindex='1'">项目信息</span></div>
          <div class="substance" v-show="activeindex==='0'">
            <div class="projectName">
              <span class="name">{{ selProject.projectName }}</span>
              <label>项目成员：{{ peopleList.hasAuth.length }}个</label>
              <span class="add" @click="dialogVisible=!dialogVisible" v-if="user.roleId==-9999"><i
                  class="el-icon-plus"></i>创建账号</span>
            </div>
            <div class="header">
              <table>
                <tr>
                  <th width="15%" class="center">访问权限</th>
                  <th width="15%" class="center">头像</th>
                  <th width="15%">姓名</th>
                  <th width="15%">手机号</th>
                  <th width="15%" class="center">身份</th>
                  <th width="25%" class="center" v-if="user.roleId!=2">操作</th>
                </tr>
              </table>
            </div>
            <div class="body">
              <table>
                <colgroup>
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="25%" v-if="user.roleId!=2">
                </colgroup>
                <tr v-for="(item,index) in peopleList.hasAuth">
                  <td style="color: #0D94FF;" class="center"><i></i>可访问</td>
                  <td class="center">
                    <div class="imgshow">
                      <img :src="item.img" alt="" class="img">
                      <template v-if="item.edit">
                        <el-upload
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :before-upload="beforeAvatarUploadItem">
                          <em class="upload">
                            <img :src="uploadIMG" alt="" v-if="uploadIMG!=''" class="uploadimg">
                            <img src="@/assets/img/upload.png" alt="" v-else>
                          </em>
                        </el-upload>
                      </template>
                    </div>
                  </td>
                  <td>
                    <span v-if="!item.edit" class="u-line-1" :title="item.realName"
                          style="padding-right:10px">{{ item.realName }}</span>
                    <input type="text" v-model="item.realNamecopy" v-else class="input">
                  </td>
                  <td>
                    <span v-if="!item.edit">{{ item.tel | number }}</span>
                    <input type="text" v-model="item.telcopy" v-else class="input" style="width:140rem">
                  </td>
                  <td class="center">
                    <span v-if="item.roleId==1">企业管理员</span>
                    <span v-else-if="item.roleId==2">普通用户</span>
                    <span v-else>超级管理员</span>
                  </td>
                  <td v-if="user.roleId==-9999" class="center">
                    <span class="reder" @click="editHandle(item);" v-if="!item.edit">编辑</span>
                    <span class="reder" @click="saveItem(item)" v-else>保存</span>
                    <span class="reder" @click="cancelItem(item)" v-if="item.edit">取消</span>
                    <span class="reder" @click="updatedePsw(item)">重置密码</span>
                    <span class="canel" @click="accessVisit('0',item)" v-if="!item.edit">取消访问</span>
                    <span class="canel" @click="deleteRow(item)" v-else>删除用户</span>
                  </td>
                  <td v-else-if="user.roleId==1" class="center">
                    <span class="reder" @click="updatedePsw(item)">重置密码</span>
                    <span class="canel" @click="accessVisit('0',item)">取消访问</span>
                  </td>
                </tr>
              </table>
              <div class="land" v-if="user.roleId!=2"><img src="@/assets/img/down.png" alt="">
                <span>以下成员没有此项目访问权限</span> <img src="@/assets/img/down.png" alt=""></img></div>
              <table v-if="user.roleId!=2">
                <colgroup>
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="15%">
                  <col width="25%">
                </colgroup>
                <tr v-for="item in peopleList.noAuth">
                  <td style="color: #999999;" class="center"><i style="background:#999999"></i>无法访问</td>

                  <td class="center">
                    <div class="imgshow">
                      <img :src="item.img" alt="" class="img">
                      <template v-if="item.edit">
                        <el-upload
                            class="avatar-uploader"
                            action=""
                            :show-file-list="false"
                            :before-upload="beforeAvatarUploadItem">
                          <em class="upload">
                            <img :src="uploadIMG" alt="" v-if="uploadIMG!=''" class="uploadimg">
                            <img src="@/assets/img/upload.png" alt="" v-else>
                          </em>
                        </el-upload>
                      </template>
                    </div>
                  </td>
                  <td>
                    <span v-if="!item.edit" class="u-line-1" :title="item.realName"
                          style="padding-right:10px">{{ item.realName }}</span>
                    <input type="text" v-model="item.realNamecopy" v-else class="input">
                  </td>
                  <td>
                    <span v-if="!item.edit">{{ item.tel | number }}</span>
                    <input type="text" v-model="item.telcopy" v-else class="input" style="width:140rem">
                  </td>
                  <td class="center">
                    <span v-if="item.roleId==1">企业管理员</span>
                    <span v-else-if="item.roleId==2">普通用户</span>
                    <span v-else>超级管理员</span>
                  </td>
                  <td v-if="user.roleId==-9999" class="center">
                    <span class="reder" @click="editHandle(item);" v-if="!item.edit">编辑</span>
                    <span class="reder" @click="saveItem(item)" v-else>保存</span>
                    <span class="reder" @click="cancelItem(item)" v-if="item.edit">取消</span>
                    <span class="reder" @click="updatedePsw(item)">重置密码</span>
                    <span class="reder" @click="accessVisit('1',item)" v-if="!item.edit">允许访问</span>
                    <span class="canel" @click="deleteRow(item)" v-else>删除用户</span>
                    <!-- <span class="reder" @click="accessVisit('1',item)">允许访问</span> -->
                  </td>
                  <td v-else-if="user.roleId==1" class="center">
                    <span class="reder" @click="updatedePsw(item)">重置密码</span>
                    <span class="reder" @click="accessVisit('1',item)">允许访问</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="substance" v-show="activeindex==='1'">
            <el-form :model="enterpriseForm" label-position="left" :rules="rules" ref="enterpriseForm"
                     label-width="105rem" class="enterprise-ruleForm">

              <el-form-item label="企业名称：" prop="firmName">
                <span v-if="!enterpriseEdit">{{ selProject.firmName }}</span>
                <div v-else>
                  <el-input v-model="enterpriseForm.firmName"></el-input>
                  <!-- <span class="tips">企业名称修改将同步至集团下所有项目</span> -->
                </div>
              </el-form-item>
              <el-form-item label="项目名称：" prop="projectName">
                <span v-if="!enterpriseEdit">{{ selProject.projectName }}</span>
                <el-input v-model="enterpriseForm.projectName" v-else></el-input>
              </el-form-item>

              <el-form-item label="园区地址：" prop="projectAddress">
                <span v-if="!enterpriseEdit">{{ selProject.projectAddress }}</span>
                <el-input v-model="enterpriseForm.projectAddress" v-else></el-input>
              </el-form-item>
              <el-form-item label="开始运行时间：" prop="projectArea">
                <span v-if="!enterpriseEdit">{{ timeFormatSeconds(selProject.deploymentTime).split(" ")[0] }}</span>
                <el-date-picker
                    v-else
                    v-model="selProject.deploymentTime"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="辖区面积：" prop="projectArea">
                <span v-if="!enterpriseEdit">{{ selProject.projectArea }}</span>
                <el-input v-model="enterpriseForm.projectArea" v-else></el-input>
              </el-form-item>
              <el-form-item label="建筑面积：" prop="buildingArea">
                <span v-if="!enterpriseEdit">{{ selProject.buildingArea }}</span>
                <div v-else>
                  <el-input v-model="enterpriseForm.buildingArea"></el-input>
                  <!-- <span class="tips">建筑面积将用于能源数据的计算</span> -->
                </div>
              </el-form-item>
              <div class="projectImgCont">
                <div class="imgshow">
                  <img :src="selProject.projectImg" alt="" class="projectImg" v-if="!enterpriseEdit">
                  <img :src="enterpriseForm.projectImg" alt="" class="projectImg" v-else>
                  <span class="upload" v-if="enterpriseEdit">
                                        <el-upload
                                            class="avatar-uploader"
                                            action=""
                                            :show-file-list="false"
                                            :before-upload="beforeAvatarUploadProject">
                                            <img src="@/assets/img/upload1.png" alt=""> 更换封面
                                        </el-upload>
                                    </span>
                </div>
                <div class="imgshow imgshow1">
                  <div class="firmLogo">
                    <img :src="selProject.firmLogo" alt="" class="projectImg1" v-if="!enterpriseEdit">
                    <img :src="enterpriseForm.firmLogo" alt="" class="projectImg1" v-else>
                  </div>
                  <span class="upload" v-if="enterpriseEdit">
                                        <el-upload
                                            class="avatar-uploader"
                                            action=""
                                            :show-file-list="false"
                                            :before-upload="beforeAvatarUploadfirmLogo">
                                            <img src="@/assets/img/upload1.png" alt=""> 上传logo
                                        </el-upload>
                                    </span>
                </div>
              </div>
              <el-form-item label="电压等级：" prop="">
                <span>{{ JSON.parse(selProject.projectDetailsInfo)['供电电压'] }} kV</span>
              </el-form-item>
              <el-form-item label="供电来源：" prop="projectPowerOrigin">
                <span v-if="!enterpriseEdit">{{ selProject.projectPowerOrigin }}</span>
                <el-input v-else v-model="enterpriseForm.projectPowerOrigin"></el-input>
              </el-form-item>
              <el-form-item label="电价：" prop="projectPowerCost">
                <div v-if="!enterpriseEdit">
                  <div v-if="enterpriseForm.electricityType==1">供电局统一电价：{{
                      enterpriseForm.projectPowerCost
                    }}{{ enterpriseForm.projectPowerCost ? '￥' : '' }}
                  </div>
                  <div v-if="enterpriseForm.electricityType==2" class="spike">
                    <span>尖:{{
                        enterpriseForm.sharpElectricityPrices
                      }}{{ enterpriseForm.sharpElectricityPrices ? '￥' : '' }}</span>
                    <span>峰:{{
                        enterpriseForm.peakElectricityPrices
                      }}{{ enterpriseForm.peakElectricityPrices ? '￥' : '' }}</span>
                    <span>平:{{
                        enterpriseForm.flatElectricityPrices
                      }}{{ enterpriseForm.flatElectricityPrices ? '￥' : '' }}</span>
                    <span>谷:{{
                        enterpriseForm.lowElectricityPrices
                      }}{{ enterpriseForm.lowElectricityPrices ? '￥' : '' }}</span>
                  </div>
                </div>
                <div v-else>
                  <el-select v-model="enterpriseForm.electricityType" placeholder="请选择" class="electrovalence">
                    <el-option
                        v-for="item in electrovalence"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                  <!-- <el-input  v-model="enterpriseForm.projectPowerCost" v-if="electrovalenceValue=='1'"></el-input> -->
                  <el-input v-model="enterpriseForm.projectPowerCost"
                            v-if="enterpriseForm.electricityType==1"></el-input>
                  <!-- <span class="tips">0.6707元是湖北省统一电价，将用于成本数据的计算</span> -->
                  <div class="valley" v-if="enterpriseForm.electricityType==2">
                    <el-input placeholder="尖" v-model="enterpriseForm.sharpElectricityPrices"></el-input>
                    <el-input placeholder="峰" v-model="enterpriseForm.peakElectricityPrices"></el-input>
                    <el-input placeholder="平" v-model="enterpriseForm.flatElectricityPrices"></el-input>
                    <el-input placeholder="谷" v-model="enterpriseForm.lowElectricityPrices"></el-input>
                  </div>
                </div>

              </el-form-item>
              <div class="jurisdiction" v-if="user.roleId==-9999">
                <div class="name"><span>功能模块访问权限</span></div>
                <div class="box" v-if="!enterpriseEdit">
                  <div class="item active" v-for="(item,index) in menuAuth">
                    <div class="">
                      <img :src="item.imga" alt="" class="img">
                      <p>{{ item.name }}</p>
                    </div>
                  </div>
                </div>
                <div class="box" v-else>
                  <div class="item" v-for="(item,index) in jurisdiction" @click="checkPurview(item,index)"
                       :class="{active:item.active}">
                    <div class="">
                      <img :src="item.active?item.imga:item.img" alt="" class="img">
                      <p>{{ item.name }}</p>
                      <img src="@/assets/img/check.png" alt="" class="check" v-if="!item.active">
                      <img src="@/assets/img/check-a.png" alt="" class="check" v-else>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="user.roleId==-9999">
                <el-button class="canel" @click="enterpriseEdit=!enterpriseEdit" v-if="enterpriseEdit">取消</el-button>
                <el-button class="save" @click="submitEnterpriseForm('enterpriseForm')" v-if="enterpriseEdit">保存
                </el-button>
                <el-button class="edit" @click="enterpriseEdit=!enterpriseEdit" v-else>编辑</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
        class="addAccount"
        title="创建账号"
        :visible.sync="dialogVisible"
        width="730rem"
        :before-close="handleClose">
      <div class="body">
        <div class="tips">创建一个新的平台账号，为账号填写基本信息和分配身份。</div>
        <div class="title">基本信息</div>
        <el-form :model="addForm" :rules="addFormrules" label-position="left" ref="addForm" label-width="100px"
                 class="addForm">
          <el-form-item label="头像" prop="img">
            <div class="imgshow">
              <img src="@/assets/img/user.png" v-if="!addForm.img||addForm.img==''" class="img">
              <img :src="addForm.img" v-else class="img">
              <span class="upload">
                                <el-upload
                                    class="avatar-uploader"
                                    action=""
                                    :show-file-list="false"
                                    :before-upload="beforeAvatarUploadAdd">
                                    <img src="@/assets/img/upload.png" alt="">
                                </el-upload>
                            </span>
            </div>
          </el-form-item>
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="addForm.realName"></el-input>
          </el-form-item>
          <el-form-item label="手机" prop="tel">
            <el-input v-model="addForm.tel"></el-input>
          </el-form-item>
          <el-form-item label="身份设置" prop="roleId" style="width:150%">
            <el-radio-group v-model="addForm.roleId">
              <el-radio :label="-9999">超级管理员</el-radio>
              <el-radio :label="1">企业管理员</el-radio>
              <el-radio :label="2">普通成员</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false" class="cancel">取 消</el-button>
        <el-button type="primary" @click="addSubmitForm('addForm')" class="sub">创 建</el-button>
      </div>
      <div class="warm">新用户初始密码为“00000000”，请提醒新用户及时修改</div>
    </el-dialog>
  </div>
</template>

<script>
import {UPDATE_AVATAR} from "../../api/upload";
import {play} from "../../api/login";
import {
  userList,
  userAccess,
  userUpdatedepsw,
  userDelete,
  userUpdate,
  projectUpdate,
  userAdd,
  updateProjectAndFirm
} from "../../api/center";
import {UPLOAD_IMAGE} from "../../api/upload";
import {userAllgroup} from '../../api/power.js'
import Base from './base'
import {dateFormat, addDay, timeFormatSeconds} from '../../util/DateUtil';

export default {
  name: "",
  data() {
    var checkAge = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("密码不能为空"));
      } else {
        if (this.ruleForm.oldPsw.length < 6 || this.ruleForm.oldPsw.length > 18) {
          callback(new Error("要求6-18位字符"));
        }
        if (this.ruleForm.oldPsw.match(/([\u4E00-\u9FA5])+/)) {
          callback(new Error("不能包含中文字符"));
        }

        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var lts = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,18}$/;
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (this.ruleForm.pass.length < 6 || this.ruleForm.pass.length > 18) {
          callback(new Error("要求6-18位字符"));
        }
        if (this.ruleForm.pass.match(/([\u4E00-\u9FA5])+/)) {
          callback(new Error("不能包含中文字符"));
        }
        if (value == this.ruleForm.oldPsw) {
          callback(new Error("新密码与旧密码一致!"));
        }
        if (!lts.test(value)) {
          callback(new Error("必须包含数字，字母，特殊符号两种或以上！"));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      var phoneReg = /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else {
        if (!phoneReg.test(value)) {
          callback(new Error('输入格式错误'));
        } else {
          callback();
        }
        callback();
      }
    };
    return {
      electrovalenceValue: 0,  //电价
      electrovalence: [
        {
          value: 2,
          label: '尖峰平谷电价'
        },
        {
          value: 1,
          label: '供电局统一电价'
        }
      ],
      dialogVisible: false,
      rules: {
        oldPsw: [
          {validator: checkAge, trigger: 'blur'}
        ],
        pass: [
          {validator: validatePass, trigger: 'blur'}
        ],
        newPsw: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入手机', trigger: 'blur'},
          {validator: checkPhone, trigger: 'blur'}
        ],
        realName: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        projectName: [
          {required: true, message: '请输入项目名称', trigger: 'blur'},
        ],
        projectArea: [
          {required: true, message: '请输入辖区面积', trigger: 'blur'},
        ],
        projectAddress: [
          {required: true, message: '请输入园区地址', trigger: 'blur'},
        ],
        projectPowerOrigin: [
          {required: true, message: '请输入供电来源', trigger: 'blur'},
        ],
      },
      peopleList: {
        hasAuth: [],
        noAuth: []
      },
      active: 0,
      selProject: {},
      uploadIMG: "", //上传图片
      activeindex: '0',
      enterpriseEdit: false,
      enterpriseForm: {
        projectArea: "",
        projectImg: "",
        projectName: "",
        projectAddress: "",
        projectPowerOrigin: "",
        firmLogo: "",
        projectPowerCost: "",
        buildingArea: "",
        firmName: "",
        electricityType: ""
      },
      addForm: {
        img: "",
        // projectIds:"",
        tel: "",
        realName: "",
        roleId: -9999
      },
      addFormrules: {
        tel: [
          {required: true, message: '请输入手机', trigger: 'blur'},
          {validator: checkPhone, trigger: 'blur'}
        ],
        realName: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
      },
      jurisdiction: [
        {
          name: "配电",
          id: "PowerDistribution",
          img: require("../../assets/img/pd.png"),
          imga: require("../../assets/img/pd-a.png"),
          active: false
        },
        {
          name: "光伏",
          id: "Photovoltaic",
          img: require("../../assets/img/gf.png"),
          imga: require("../../assets/img/gf-a.png"),
          active: false
        },
        {
          name: "能耗",
          id: "EnergyConsumption",
          img: require("../../assets/img/nh.png"),
          imga: require("../../assets/img/nh-a.png"),
          active: false
        },
        {
          name: "计费",
          id: "PaymentMeter",
          img: require("../../assets/img/jf.png"),
          imga: require("../../assets/img/jf-a.png"),
          active: false
        },
        // {
        //     name:"大屏展示",
        //     id:"3D",
        //     img:require("../../assets/img/3D.png"),
        //     imga:require("../../assets/img/3D-a.png"),
        //     active:false
        // }
      ],
      menuAuth: []
    }
  },
  components: {
    Base
  },
  filters: {
    number: (data, n) => {
      if (data) {
        return data.substr(0, 3) + '****' + data.substr(7);
      } else {
        return ""
      }

    }
  },
  computed: {
    user() {
      return this.$store.state.homeitem.user
    },
    projectGroup() {
      let list = []
      this.$store.state.project.projectGroup.forEach(item => {
        if (item.projectList) {
          item.projectList.forEach(elm => {
            list.push(elm)
          })
        }
      })
      this.selProject = list[this.active]

      // this.enterpriseForm.projectArea = list[this.active].projectArea
      // this.enterpriseForm.projectAddress = list[this.active].projectAddress
      // this.enterpriseForm.projectPowerOrigin = list[this.active].projectPowerOrigin
      // this.enterpriseForm.projectImg = list[this.active].projectImg
      // this.enterpriseForm.projectName = list[this.active].projectName
      return list
    },
  },
  watch: {
    selProject(n, o) {
      // this.jurisdiction.forEach(item=>{item.active = false})
      // this.enterpriseForm.projectArea = n.projectArea
      // this.enterpriseForm.projectAddress = n.projectAddress
      // this.enterpriseForm.projectPowerOrigin = n.projectPowerOrigin
      // this.enterpriseForm.projectImg = n.projectImg
      // this.enterpriseForm.projectName = n.projectName
      // this.enterpriseForm.firmName = n.firmName
      this.enterpriseForm = n


      this.initTable();

      this.jurisdiction.forEach(item => {
        item.active = false
      })
      if (this.selProject.menuAuth) {
        let list = this.selProject.menuAuth.split(",")
        let newlist = []
        this.jurisdiction.forEach(elm => {
          list.forEach(item => {
            if (item == elm.id) {
              elm.active = true
              newlist.push(elm)
            } else {
              // elm.active = false
            }
          })
        })
        this.menuAuth = newlist
      } else {
        this.menuAuth = []
      }
    },
    "$store.state.project.projectGroup"(n, o) {
      let list = []
      n.forEach(item => {
        if (item.projectList) {
          item.projectList.forEach(elm => {
            list.push(elm)
          })
        }
      })
      this.selProject = list[this.active]


      // this.enterpriseForm.projectArea = list[this.active].projectArea
      // this.enterpriseForm.projectAddress = list[this.active].projectAddress
      // this.enterpriseForm.projectPowerOrigin = n.projectPowerOrigin
      // this.enterpriseForm.projectImg = list[this.active].projectImg
      // this.enterpriseForm.projectName = list[this.active].projectName
    }
  },
  mounted() {
    this.initTable();
  },
  methods: {
    timeFormatSeconds,
    uploadName() {
      this.initTable();
    },
    checkPurview(item, index) {
      item.active = !item.active
    },
    handleClose() { //关闭弹窗
      this.dialogVisible = false
      this.addForm = {
        img: "",
        projectIds: "",
        tel: "",
        realName: "",
        roleId: -9999
      }
    },
    //创建账号上传头像
    beforeAvatarUploadAdd(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像只能是 JPG和PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像大小不能超过 2MB!");
        return false;
      }
      UPDATE_AVATAR(file).then((res) => {
        if (res.data.status) {
          this.addForm.img = res.data.data.path
        }
      });
      return false;
    },
    //创建账号
    addSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            firmId: this.selProject.firmId,
            projectIds: this.selProject.projectId,
            img: this.addForm.img,
            realName: this.addForm.realName,
            roleId: this.addForm.roleId,
            tel: this.addForm.tel
            // ...this.addForm
          }
          userAdd(obj).then((res) => {
            if (res.data.status) {
              this.$message.success('创建成功！');
              this.dialogVisible = false;
              this.addForm = {
                img: "",
                projectIds: "",
                tel: "",
                realName: "",
                roleId: -9999
              }
              this.initTable();
            } else {
              this.$message.error(res.data.errMsg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editHandle(item) {
      this.peopleList.noAuth = this.peopleList.noAuth.map(e => {
        e.edit = false;
        return e
      })
      this.peopleList.hasAuth = this.peopleList.hasAuth.map(e => {
        e.edit = false;
        return e
      })
      item.edit = !item.edit;
    },
    uploadProjectGroup() {
      userAllgroup(this.$store.state.homeitem.user.uid).then((res) => {
        let projectGroup = res.data.data
        this.$store.commit("setProjectGroup", projectGroup);
        let data = projectGroup.filter(e => e.firmId == this.$store.state.project.EnterpriseInfo.firmId)[0]
        this.$store.commit("setEnterpriseInfo", data);
      })
      play.currentProjectInfo().then((res) => {
        this.$store.commit(
            "setProjectInfo",
            res.data.data.project
        );
      })

    },
    submitEnterpriseForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let menuAuth = []
          this.jurisdiction.forEach(e => {
            if (e.active) {
              menuAuth.push(e.id)
            }
          })
          if (menuAuth.length == 0) {
            this.$message.info("请至少选择一项功能模块");
            return
          }
          let obj = {
            menuAuth: menuAuth.toString(),
            projectId: this.selProject.projectId,
            projectArea: this.enterpriseForm.projectArea,
            projectImg: this.enterpriseForm.projectImg,
            projectName: this.enterpriseForm.projectName,
            projectAddress: this.enterpriseForm.projectAddress,
            projectPowerOrigin: this.enterpriseForm.projectPowerOrigin,
            firmName: this.enterpriseForm.firmName,
            firmId: this.enterpriseForm.firmId,
            buildingArea: this.enterpriseForm.buildingArea,
            firmLogo: this.enterpriseForm.firmLogo,
            electricityType: this.enterpriseForm.electricityType,
            deploymentTime: this.enterpriseForm.deploymentTime.split("T")[0]
            // ...this.enterpriseForm
          }
          if (obj.electricityType == 1) {  //供电局
            obj['projectPowerCost'] = this.enterpriseForm.projectPowerCost
          } else {
            obj['sharpElectricityPrices'] = this.enterpriseForm.sharpElectricityPrices
            obj['peakElectricityPrices'] = this.enterpriseForm.peakElectricityPrices
            obj['flatElectricityPrices'] = this.enterpriseForm.flatElectricityPrices
            obj['lowElectricityPrices'] = this.enterpriseForm.lowElectricityPrices
          }
          updateProjectAndFirm(obj).then((res) => {
            if (res.data.status) {
              this.uploadProjectGroup();
              this.$message.success('修改成功！');
              this.enterpriseEdit = false
            } else {
              this.$message.error("修改失败");
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //删除
    deleteRow(item) {
      let _this = this
      let text = "确定将<i style='color:#0D94FF'>" + item.realName + "</i>从成员列表中删除？ <br>若您想取消该成员的项目访问权限，请关闭弹窗，点击<i style='color:#FD4238'>取消访问</i>。"
      this.$confirm(text, '删除成员', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: '',
        customClass: "message_box"
      }).then(() => {

        this.deleteUser(item)

      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消删除'
        });
      });
    },
    //删除用户
    async deleteUser(user) {
      let data = {
        uid: user.uid
      }
      let res = await userDelete(data)
      if (res.data.code == 200) {
        this.$message({
          type: 'success',
          message: res.data.msg
        });
        this.initTable()
      } else {
        this.$message.error(res.data.errMsg)
      }
    },
    //取消操作
    cancelItem(item) {
      this.$confirm('取消不会保存当前更改。', '确认取消吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: '',
        customClass: "message_box"
      }).then(() => {
        item.edit = !item.edit;
        item.realNamecopy = item.realName
        item.telcopy = item.tel
        this.uploadIMG = ""
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },
    //保存修改成员
    async saveItem(item) {
      let data = {
        uid: item.uid,
        img: this.uploadIMG,
        realName: item.realNamecopy,
        tel: item.telcopy
      }
      if (item.realNamecopy == "") {
        this.$message.error("请填写姓名");
        return
      }
      var phoneReg = /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/
      if (item.telcopy === '') {
        this.$message.error("请填写手机号");
        return
      } else {
        if (!phoneReg.test(item.telcopy)) {
          this.$message.error("手机号输入格式错误");
          return
        }
      }
      let res = await userUpdate(data)
      if (res.data.code == 200) {
        this.$message({
          type: 'success',
          message: "操作成功！"
        });
        this.uploadIMG = ""
        this.initTable()
      } else {
        this.$message.error(res.data.errMsg)
      }
    },
    //重置密码
    updatedePsw(item) {
      this.$confirm('重置后密码为“00000000”', '确认重置该成员的密码吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: '',
        customClass: "message_box"
      }).then(() => {
        userUpdatedepsw({uid: item.uid}).then(res => {
          if (res.data.code == 200) {
            this.$message.success("操作成功！");
            this.initTable()
          } else {
            this.$message.error(res.data.errMsg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消'
        });
      });
    },
    accessVisit(type, item) {
      let obj = {
        accessFlag: type,
        projectId: this.selProject.projectId,
        userId: item.uid
      }
      userAccess(obj).then(res => {
        if (res.data.code == 200) {
          this.$message.success("操作成功！");
          this.initTable()
        }
      })
    },
    selItem(item, index) {
      this.active = index;
      this.selProject = item;
    },
    initTable() {
      userList({projectId: this.selProject.projectId}).then(res => {
        this.peopleList.hasAuth = res.data.data.hasAuth.map(e => {
          e.edit = false;
          e.telcopy = e.tel;
          e.realNamecopy = e.realName;
          e.imgcopy = e.img;
          return e
        })
        this.peopleList.noAuth = res.data.data.noAuth.map(e => {
          e.edit = false;
          e.telcopy = e.tel;
          e.realNamecopy = e.realName;
          e.imgcopy = e.img;
          return e
        })
      })
    },
    //上传头像
    beforeAvatarUploadItem(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
      UPDATE_AVATAR(file).then((res) => {
        if (res.data.status) {
          this.uploadIMG = res.data.data.path

        }
      });

      return false;
      // return isJPG && isLt2M;
    },//上传项目图
    beforeAvatarUploadProject(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      UPLOAD_IMAGE(file).then((res) => {
        if (res.data.status) {
          this.enterpriseForm.projectImg = res.data.data.path
        }
      });

      return false;
      // return isJPG && isLt2M;
    },
    beforeAvatarUploadfirmLogo(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      UPLOAD_IMAGE(file).then((res) => {
        if (res.data.status) {
          this.enterpriseForm.firmLogo = res.data.data.path
        }
      });

      return false;
      // return isJPG && isLt2M;
    },
  },
}
</script>
<style lang="less" scoped>
.spike {
  span {
    margin-right: 20px;
  }
}

.projectImgCont {
  .imgshow {
    display: inline-block;
    margin-right: 20px;
  }
}

.jurisdiction {
  margin-bottom: 20px;

  .name {
    font-size: 18rem;
    font-weight: bold;
    position: relative;
    .h(50);

    span {
      background: #ffffff;
      padding-right: 10px;
      position: relative;
      display: inline-block;
      z-index: 9;
    }
  }

  .name::after {
    content: "";
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    width: 100%;
    display: block;
    top: 12px;
    position: absolute;
  }

  .box {
    .item {
      .w(130);
      // width: 196rem;
      height: 116rem;
      border-radius: 8rem;
      border: 1px solid #CCCCCC;
      text-align: center;
      display: inline-block;
      margin-right: 15rem;
      position: relative;
      font-size: 24rem;
      cursor: pointer;

      .img {
        height: 23px;
        margin-bottom: 5px;
      }

      > div {
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
    }

    .active {
      background: rgba(13, 148, 255, 0.15);
      border: 1px solid rgba(13, 148, 255, 0.15);
      color: #0D94FF;
    }

    .check {
      position: absolute;
      right: 10px;
      top: 5px;
      width: 24rem;
    }
  }
}

/deep/ .addAccount {
  .warm {
    text-align: center;
    color: #999999;
  }

  // .el-dialog__headerbtn .el-dialog__close{
  //     color: #333333;
  //     font-size: 24px;
  //     // font-weight: 600;
  // }
  .dialog-footer {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 20px;

    .cancel {
      width: 168rem;
      height: 56rem;
      line-height: 56rem;
      padding: 0;
      background: #ffffff;
      border-radius: 28rem;
      font-size: 18rem;
      font-weight: bold;
      border: 1px solid #E5E5E5;
      color: #333333
    }

    .sub {
      width: 168rem;
      height: 56rem;
      line-height: 56rem;
      padding: 0;
      background: #0D94FF;
      border-radius: 28rem;
      font-size: 18rem;
      font-weight: bold;
    }
  }

  // .el-dialog{
  //     border-radius: 12px;
  // }
  // .el-dialog__header{
  //     border-bottom: 0;
  //     padding:20px 20px 10px 30px;
  // }
  // .el-dialog__title{
  //     font-size: 24rem;
  //     font-weight: bold;
  // }
  // .el-dialog__body{
  //     color: #333333;
  // }
  .tips {
    font-size: 18rem;
  }

  .title {
    font-size: 18rem;
    font-weight: bold;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    padding-bottom: 8rem;
    margin-top: 40rem;

  }

  .title::before {
    content: "";
    border-left: 3px solid #0D94FF;
    padding-right: 10px;
    height: 18px;
    line-height: 18px;
  }

  .el-form-item__label {
    font-size: 18rem;
    font-weight: bold;
    color: #333333;
  }

  .el-input__inner {
    height: 36px;
    color: #333333;
  }

  .el-form-item {
    margin: 22rem 0
  }

  .el-input {
    // width: 442rem;
  }

  .el-dialog__body {
    padding: 20px 30px;
  }

  .body {
    padding-right: 20%;
  }

  .imgshow {
    position: relative;
    width: 80px;
    height: 80px;
    display: inline-block;
    text-align: center;

    .img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }

    .avatar-uploader {
      display: inline-block;
    }

    .upload {
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      line-height: 80px;
      cursor: pointer;

      img {
        vertical-align: middle;
      }

      .uploadimg {
        width: 100%;
        height: 100%;
      }
    }
  }
}

/deep/ .el-form-item__label:before {
  content: none !important;
}

/deep/ .enterprise-ruleForm {
  padding-top: 20px;
  // height:calc(100% - 10vh);
  // overflow: auto;
  .valley {
    display: inline-block;

    .el-input {
      width: 127rem;
      margin-right: 7px;
    }
  }

  .electrovalence .el-input {
    width: auto;
    margin-right: 7px;
  }

  .el-form-item__label, .el-form-item__content {
    font-size: 18rem;
    color: #333333;
  }

  .el-form-item {
    margin-bottom: 15px;
  }

  .el-form-item__label {
    width: auto !important
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .tips {
    color: #999999;
    font-size: 14px;
    padding-left: 20px;
    width: 40%;
    line-height: 20px;
    vertical-align: middle;
    display: inline-block;
  }

  .imgshow {
    margin-bottom: 20px;

    .projectImg {
      width: 240rem;
      height: 136rem;
      border-radius: 4px;
      vertical-align: middle;
    }
  }

  .imgshow1 {


    .projectImg1 {
      // width: 136rem;
      // height: 136rem;
      width: 69rem;
      border-radius: 4px;
      vertical-align: middle;
    }

    .firmLogo {
      background: #EEEEEE;
      border-radius: 4px;
      width: 136rem;
      height: 136rem;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      line-height: 136rem;
    }
  }

  .el-input {
    width: 45%;
  }

  .upload {
    width: 114px;
    height: 32px;
    line-height: 32px;
    background: #0D94FF;
    border-radius: 4px;
    color: #ffffff;
    display: inline-block;
    text-align: center;
    font-size: 16rem;
    margin-left: 30px;
    vertical-align: bottom;

    img {
      vertical-align: middle;
    }
  }

  .save {
    width: 120px;
    height: 40px;
    background: #0D94FF;
    border-radius: 4px;
    color: #ffffff;
    border: 0;
  }

  .canel {
    width: 120px;
    height: 40px;

  }

  .edit {
    width: 120px;
    height: 40px;
    background: #0D94FF;
    border-radius: 4px;
    color: #ffffff;
    border: 0;
  }
}

/deep/ .ruleForm {
  .back {
    // height: 34rem;
    // line-height: 34rem;
    background: #01AB65;
    border-radius: 4rem;
    color: #ffffff;
    padding: 7rem 12rem;
  }

  .el-form-item__label {
    font-size: 18rem;
    font-weight: bold;
    color: #333333;
  }

  .el-input__inner {
    height: 36px;
    color: #333333;
  }

  .el-form-item {
    margin: 22rem 0
  }

  .el-input {
    width: 160rem;
  }

  .btn {
    float: right;
    width: 116rem;
    height: 36rem;
    line-height: 36rem;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 18rem;
    text-align: center;
    color: #0D94FF;
    font-size: 18rem;
    cursor: pointer;
    vertical-align: middle;
  }
}

.PersonalCenter {
  width: 100%;
  height: 100%;
  display: flex;

  .left {
    .w(592);
    height: 100%;
    box-shadow: 0px 1px 8px 0px rgba(17, 40, 76, 0.16);
    border-radius: 8px;
    background: url('../../assets/img/bg.png') top no-repeat #FFFFFF;
    margin-right: 10px;
    padding: 0 24rem;
    position: relative;
  }

  .right {
    background: #FFFFFF;
    flex: 1;
    min-width: auto;
    padding: 0 24rem;

    .title {
      height: 60rem;

      span {
        font-size: 16rem;
        font-weight: bold;
        border-top: 2px solid #409EFF;
        line-height: 60rem;
        display: inline-block;
      }
    }

    .cont {
      display: flex;
      height: calc(100% - 80rem);
    }

    .projectlist {
      border: 1px solid #CCCCCC;
      padding: 0 17rem;
      height: 100%;
      overflow: auto;
      .w(264);

      .all {
        font-size: 16px;
        line-height: 50rem;
      }

      .cont {
        justify-content: space-between;
      }

      .list {
        .item {
          border: 1px solid #CCCCCC;
          .h(178);
          border-radius: 8px;
          margin-bottom: 18rem;
          overflow: hidden;
          cursor: pointer;
          opacity: 0.6;

          img {
            .h(138);
            width: 100%
          }

          .name {
            font-size: 16px;
            color: #999999;
            line-height: 32rem;
            padding: 0 20rem;
          }
        }

        .active {
          border: 1px solid #0D94FF;
          box-shadow: 0px 4px 12px 0px rgba(13, 148, 255, 0.5);
          opacity: 1
        }
      }
    }

    .people {
      flex: 1;
      min-width: auto;
      padding-left: 24rem;

      .tag {
        height: 40rem;
        border-top: 1px solid rgba(0, 0, 0, 0.15);

        span {
          font-size: 16rem;
          font-weight: bold;
          border-radius: 2px;
          line-height: 50rem;
          display: inline-block;
          margin-right: 20px;
          cursor: pointer;
          margin-top: -2px;
        }

        .active {
          color: #0D94FF;
          border-top: 2px solid #0D94FF;
        }
      }

      .substance {
        height: calc(100% - 40rem);
        overflow: auto;
      }

      .projectName {
        line-height: 70rem;

        .name {
          font-size: 18rem;
          font-weight: bold;
          color: #0D94FF;
        }

        label {
          font-size: 16rem;
          margin-left: 18%;
        }

        .add {
          width: 112rem;
          height: 36rem;
          line-height: 36rem;
          background: #0D94FF;
          border-radius: 18rem;
          color: #ffffff;
          text-align: center;
          float: right;
          font-size: 16rem;
          font-weight: bold;
          cursor: pointer;
          margin-top: 18rem;

          i {
            margin-right: 3px;
            font-weight: bold;
          }
        }

      }

      .land {
        height: 32px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(17, 40, 76, 0.16);
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        color: #999999;
        position: relative;
        z-index: 2;

        span {
          display: inline-block;
        }

        span::before, span::after {
          content: "";
          border-bottom: 1px solid #CCCCCC;
          width: 150rem;
          display: inline-block;
          vertical-align: middle;
          margin: 0 10px
        }

        img {
          vertical-align: middle;
          width: 18px;
        }
      }

      table {
        font-size: 16rem;
        width: 100%;
        border-collapse: collapse;

        th {
          height: 64rem;
          background: #E5E9EF;
          text-align: left;
        }

        .center {
          text-align: center;
        }

        tr {
          border-bottom: 1px solid rgba(0, 0, 0, 0.15);

          td {
            // text-align: center;
            height: 63rem;

            .input {
              width: 100rem;
              height: 40rem;
              background: #FFFFFF;
              border: 1px solid #CCCCCC;
              border-radius: 2px;
              padding-left: 10px;
            }

            .imgshow {
              position: relative;
              width: 48rem;
              height: 48rem;
              display: inline-block;

              .img {
                width: 48rem;
                height: 48rem;
                vertical-align: middle;
              }

              .avatar-uploader {
                display: inline-block;
              }

              .upload {
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                line-height: 48rem;
                cursor: pointer;

                img {
                  vertical-align: middle;
                }

                .uploadimg {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            i {
              width: 10px;
              height: 10px;
              background: #01AB65;
              border-radius: 50%;
              display: inline-block;
              margin-right: 5px;
            }

            .reder {
              color: #0D94FF;
              margin: 0 5px;
              cursor: pointer;
            }

            .canel {
              color: #FD4238;
              margin: 0 5px;
              cursor: pointer;
            }
          }
        }

      }

      .body {
        .h(720);
        overflow: auto;
      }
    }
  }
}
</style>